import { Button, Typography } from "@mui/material";
import { MprcLink } from "components";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { TrainingPanelCacheData } from "views/dashboard/TrainingPanel/shared";

interface IProps {
    data: TrainingPanelCacheData;
    filterChanged: boolean;
    enableCacheRebuild: boolean;
    onLoadNewData: () => void;
}

export const PanelFilterState = ({ data, filterChanged, enableCacheRebuild, onLoadNewData }: IProps) => {
    const { t } = useTranslation("dashboard");

    return data.processing
        ? <Typography variant="caption">{t("TrainingPanel.Run.Processing")}</Typography>
        : data == null || data.cache == null
            ? <Button variant="contained" onClick={() => onLoadNewData()}>
                {t("TrainingPanel.Run.ProcessData")}
            </Button>
            : filterChanged
                ? <Button variant="contained" color="info" onClick={() => onLoadNewData()}>
                    {t("TrainingPanel.Run.ApplyFilterAndProcess")}
                </Button>
                : !filterChanged &&
                <Typography variant="caption">
                    {t("TrainingPanel.Run.DataProccessed")} {Formaters.performaDate(data.cache.processingDate)}
                    {enableCacheRebuild &&
                        <MprcLink onClick={() => onLoadNewData()} fontSize="inherit" >
                            &nbsp;&bull;&nbsp;{t("TrainingPanel.Run.Reprocess")}
                        </MprcLink>
                    }
                </Typography>;
};
